<template>
  <div>
    <credit-card-field v-model="inputVal" />
    <div class="creditcard-input-area">
      <input
        v-if="!readonly && !disabled"
        v-model="inputVal.number"
        v-validate="{creditcard_number: true, required: true}"
        :placeholder="$t('credit_card.placeholder.number')"
        type="text"
        name="number"
        class="form-control"
        @input="onInput"
      >
      <div v-show="hasError('number')" :class="{'invalid-feedback': true, 'show-invalid': hasError('number')}">
        {{ errors.first('number') }}
      </div>
      <input
        v-if="!readonly && !disabled"
        v-model="inputVal.name"
        v-validate="{required: true}"
        :placeholder="$t('credit_card.placeholder.name')"
        type="text"
        name="name"
        class="form-control"
        @input="onInput"
      >
      <div v-show="hasError('name')" :class="{'invalid-feedback': true, 'show-invalid': hasError('name')}">
        {{ errors.first('name') }}
      </div>
      <input
        v-if="!readonly && !disabled"
        v-model="inputVal.expiry"
        v-validate="{creditcard_expiry: true, required: true}"
        :placeholder="$t('credit_card.placeholder.expiry')"
        type="text"
        name="expiry"
        class="form-control"
        @input="onInput"
      >
      <div v-show="hasError('expiry')" :class="{'invalid-feedback': true, 'show-invalid': hasError('expiry')}">
        {{ errors.first('expiry') }}
      </div>
      <input
        v-if="!readonly && !disabled"
        v-model="inputVal.cvc"
        v-card-focus
        v-validate="{creditcard_cvc: true, required: true}"
        :placeholder="$t('credit_card.placeholder.cvc')"
        type="text"
        name="cvc"
        class="form-control"
        @input="onInput"
      >
      <div v-show="hasError('cvc')" :class="{'invalid-feedback': true, 'show-invalid': hasError('cvc')}">
        {{ errors.first('cvc') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      inputVal: {
        number: '',
        name: '',
        expiry: '',
        cvc: ''
      }
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    }
  },
  mounted() {
    if (this.value) {
      this.inputVal = this.value
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
      this.$validator.validateAll()
    }
    $(window).on('resize', this.resize)
    this.resize()
  },
  beforeDestroy() {
    $(window).off('resize', this.resize)
  },
  methods: {
    resize() {
      const cardContainer = $(this.$el).find('.jp-card-container')
      cardContainer.height((cardContainer.width() * 200) / 315)
    },
    hasError(name) {
      return this.errors.has(name)
    },
    onInput(e) {
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
    }
  }
}
</script>

<style scoped>
.creditcard-input-area {
  max-width: 350px;
  padding: 5px 0;
  width: 100%;
  margin: auto;
}
.creditcard-input-area > .form-control {
  margin: 5px 0;
}
.show-valid,
.show-invalid {
  display: block !important;
}
@media (max-width: 767px) {
  >>> .jp-card-container {
    width: auto;
  }
  >>> .jp-card-container .jp-card {
    min-width: auto;
  }
  >>> .jp-card .jp-card-front .jp-card-lower .jp-card-number {
    font-size: 1.1rem;
  }
  >>> .jp-card .jp-card-front .jp-card-lower .jp-card-name {
    font-size: 1.1rem;
  }
  >>> .jp-card .jp-card-front .jp-card-lower .jp-card-expiry {
    width: 30%;
  }
  >>> .jp-card .jp-card-front .jp-card-lower .jp-card-number {
    margin-bottom: 20px;
  }
}
</style>
